import { CourseBounds, LocalCoordinates } from '@/types/course.types';
import { LatLng } from '@/types/shot.types';

/**
 * Convert latitude/longitude to local 3D coordinates
 * @param lat Latitude
 * @param lng Longitude
 * @param bounds Course geographic bounds
 * @param courseWidth Width in 3D space (meters)
 * @param courseHeight Height in 3D space (meters)
 * @returns Local x, z coordinates
 */
export function latLngToLocal(
  lat: number,
  lng: number,
  bounds: CourseBounds,
  courseWidth: number,
  courseHeight: number
): LocalCoordinates {
  const latRange = bounds.north - bounds.south;
  const lngRange = bounds.east - bounds.west;

  const x = ((lng - bounds.west) / lngRange - 0.5) * courseWidth;
  const z = -((lat - bounds.south) / latRange - 0.5) * courseHeight;

  return { x, z };
}

/**
 * Convert LatLng object to local coordinates
 */
export function latLngToLocalFromObject(
  coord: LatLng,
  bounds: CourseBounds,
  courseWidth: number,
  courseHeight: number
): LocalCoordinates {
  return latLngToLocal(coord.lat, coord.lng, bounds, courseWidth, courseHeight);
}
